/**
 * Floorplan rendering bench — `/$org/plan-rendering`.
 *
 * A developer surface, like `/$org/patterns`: it renders the plan primitives
 * through the production renderer so that geometry regressions are visible
 * instead of merely possible. English route segment, like every other route.
 */
import { createFileRoute, useParams } from '@tanstack/react-router'
import { PlanRenderingLab } from '../../components/plan-editor/PlanRenderingLab'
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs'
import { PageHeader } from '../../components/shared/PageHeader'
import { SECTION_ICONS } from '../../lib/section-icons'

export const Route = createFileRoute('/$org/plan-rendering')({
    component: PlanRenderingRoute,
})

function PlanRenderingRoute() {
    const { org } = useParams({ from: '/$org/plan-rendering' })
    useBreadcrumbs([
        { title: 'Home', path: `/${org}` },
        { title: 'Plan rendering' },
    ])

    return (
        <div className="flex flex-col gap-4">
            <PageHeader
                icon={SECTION_ICONS.planRendering}
                title="Plan rendering"
                description="Every case is drawn by the editor's own renderer. If something looks wrong here, it is wrong on the plans too."
            />
            <PlanRenderingLab org={org} />
        </div>
    )
}
